import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Order } from '../common/model/dto/order/order';
import OrdersService from '../services/orders.service';

export function useAdminOrderMutations(orderId: string) {
  const qc = useQueryClient();

  const invalidateOrderQuery = () =>
    qc.invalidateQueries({ queryKey: ['admin-order', orderId] });

  const invalidateOrderActivitiesQuery = () =>
    qc.invalidateQueries({ queryKey: ['admin-order-activities', orderId] });

  const invalidateOrderQueries = () => {
    invalidateOrderQuery();
    invalidateOrderActivitiesQuery();
  };

  const updateOrder = useMutation({
    mutationFn: (updates: Partial<Order>) =>
      OrdersService.updateBackendOrder(updates, orderId),
    onSuccess: invalidateOrderQueries,
  });

  const submitOrder = useMutation({
    mutationFn: () => OrdersService.submitBackendOrder(orderId),
    onSuccess: invalidateOrderQueries,
  });

  return {
    updateOrder,
    submitOrder,
  };
}
